import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "reports",
    name: "Reports",
    version: "0.1.0",
    tier: "core",
    accent: "brand",
    dependsOn: ["sites"],
    description: "Every report in one place: gross profit, sales and cost history, best sellers, pricing checks, waste, fuel, the car wash and coffee machines, the cash office and the accounts extract, audits and site checks. Quick filters, charts, compare with last week or last year, Excel and saved views.",
    permissions: {
        view: "See reports on how your sites are run (audits, checks, maintenance, tasks)",
        trading: "See trading reports: sales, margin, prices, waste, fuel, machines and the cash office",
        manage: "Choose which reports the company sees, their order and names, and share saved views",
    },
    grants: {
        "Head office": ["view", "trading", "manage"],
        "Area manager": ["view", "trading"],
        "Site manager": ["view", "trading"],
        Supervisor: ["view"],
    },
    nav: [
        { label: "All reports", path: "/reports", section: "reports", tab: "All reports", tabIcon: "chart", permission: "view", icon: "chart", order: 6, blurb: "Sales, margin, fuel, waste, audits and more in one place" },
        // Analysing stays in its section (Jamie, 22/10/26: "I don't want to leave Shop if I'm analysing, the same as when
        // I'm digging into fuel sales"): the same pages under Shop's and Fuel's tabs. /reports/shop/view?r=… and
        // /reports/fuel/view?r=… are any report opened from there.
        // Its own Shop tab (22/10/26): ordering moved into the Co-op catalogue, which freed Ordering's tab.
        { label: "Sales", path: "/reports/shop", section: "shop", tab: "Sales", tabIcon: "chart", permission: "trading", icon: "chart", order: 10.2, blurb: "Shop sales down to each product, gross profit, best sellers, waste" },
        { label: "Fuel sold", path: "/reports/fuel", section: "fuel", tab: "Overview", permission: "trading", icon: "chart", order: 40.5, requires: ["fuel", "wetstock"], when: { fuel: true }, blurb: "Litres by site and grade against before, and the fuel reports" },
        // Data feeds belong with the company's data settings (Jamie, 19/10/26); the Reports page keeps its button too.
        { label: "Data feeds", path: "/reports/feeds", section: "settings", kind: "settings", tab: "Data", tabIcon: "broadcast", permission: "manage", icon: "broadcast", order: 917, blurb: "Till sales, waste and product files coming in, and their keys" },
    ],
    // The till back offices the daily feeds come from, as tiles in the set-up tool's Your systems (29/10/26). Each site's
    // own system is its Sites answer; logos are uploaded in the console.
    integrations: [
        { id: "cbe", name: "CBE back office", what: "Till sales, waste and products from CBE back offices, every day", setup: [] },
        { id: "vme", name: "VME back office", what: "Till sales, waste and products from VME back offices, every day", setup: [] },
    ],
    setup: [
        {
            id: "data-feeds", title: "Data feeds (till sales, waste, products)", scope: "tenant", blocking: false,
            link: { label: "Open Data feeds", path: "/reports/feeds" },
            why: "Trading reports, margins and the rent review need the tills' sales, waste and product files every day. Set up a feed key and send them under Settings → Data → Data feeds.",
            fields: [],
        },
    ],
});
